// Externals
import React from "react";
// import { useSelector } from "react-redux";

// Scss
import "./Floor.scss";

// Assets
import Floor1 from "../../static/svg/new-floor-1.svg";
import Floor2 from "../../static/svg/new-floor-2.svg";
import Floor3 from "../../static/svg/new-floor-3.svg";
import Floor4 from "../../static/svg/new-floor-4.svg";
import Floor5 from "../../static/svg/new-floor-1.svg";

const floors = [
	<div className="new-floor" style={{ backgroundImage: `url(${Floor1})` }} />,
	<div className="new-floor" style={{ backgroundImage: `url(${Floor2})` }} />,
	<div className="new-floor" style={{ backgroundImage: `url(${Floor3})` }} />,
	<div className="new-floor" style={{ backgroundImage: `url(${Floor4})` }} />,
	<div className="new-floor" style={{ backgroundImage: `url(${Floor5})` }} />,
];

const Floor = (props) => {
	return <div className="floor">{floors[props.id - 1]}</div>;
};

export default Floor;
